(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.special-company.pdf.view
  (:require
   [clojure.string :as s]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.card.pdf.view :refer [card]]
   [frontend.ui.component.lp-portal.column.pdf.view
    :refer [column columns columns-2-to-1]]
   [frontend.ui.component.lp-portal.page.pdf.view
    :as page]
   [frontend.ui.component.lp-portal.stacked-text-group.pdf.view
    :refer [stacked-text-group]]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [potpuri.core :as potpuri]
   [clojure.string :as string]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]))

(defn- latest-development-figures-board
  [board]
  (let [[section-title board-members] (:figures board)]
    (card
     section-title
     (->> board-members
          (map (fn [board-member]
                 (let [[member-name & member-title-strs] (s/split board-member ", ")]
                   {:text   [member-name
                             (when member-title-strs
                               ", ")
                             {:text    (s/join ", " member-title-strs)
                              :color   (color [:pdf :stack :value-list])
                              :italics true}]
                    :margin [0 0 0 4]})))))))

(defn- latest-development-page
  [report-data]
  (page/page
   (page/third-column-background)
   (page/page-title {:page-title (:holding-name report-data)})
   (columns-2-to-1
    (card "Latest Development"
          (text-content/rich-content (->> report-data
                                          :overview
                                          :latest-development
                                          :rich-content)))
    (latest-development-figures-board (-> report-data
                                          :overview
                                          :board)))))

(defn- case-overview-page
  [report-data]
  (page/page
   (page/third-column-background)
   (page/page-title {:page-title (:holding-name report-data) :toc-item true})
   (columns-2-to-1
    (card
     "Case Overview"
     (text-content/rich-content (->> report-data
                                     :overview
                                     :case-overview
                                     :rich-content)))
    {:margin [0 15 0 0]
     :stack  (concat (->> report-data
                          :overview
                          :overview-figures
                          :figures
                          (mapv
                           (fn [[label value]]
                             (stacked-text-group label value))))
                     [(text-content/optional-footer (-> report-data
                                                        :overview
                                                        :overview-figures))])})))

(defn- overview-pages
  [report-data]
  [(case-overview-page report-data)
   (latest-development-page report-data)])


(defn- company-3-page
  [report-data]
  (page/page
   (page/page-title {:page-title (:holding-name report-data)})
   (columns
    (card "Financial Performance"
          (text-content/rich-content (-> report-data
                                         :financial-performance
                                         :rich-content)))
    [(column/column
      (card
       "Financials"
       {:svg   (chart-view/chart-svg "highcharts"
                                     (potpuri/deep-merge
                                      (-> report-data
                                          :financials
                                          :figures)
                                      {:chart {:width  600
                                               :height 240}}))
        :width (int page/half-page-without-margins)}
       (text-content/optional-footer (:financials report-data)) ; is this ever used?
      ))
     (column/column
      (card
       "Enterprise value"
       {:svg   (chart-view/chart-svg "highcharts"
                                     (potpuri/deep-merge (-> report-data
                                                             :enterprise-value
                                                             :figures)
                                                         {:chart {:width  600
                                                                  :height 240}}))
        :width (int page/half-page-without-margins)}
       (text-content/optional-footer (:enterprise-value report-data)) ; is this ever used?
      ))])))

(defn- value-creation-plan-page
  [report-data]
  (page/page
   (page/page-title {:page-title (:holding-name report-data)})
   (column
    (card
     "Value creation plan & exit vision"
     (text-content/rich-content (-> report-data
                                    :value-creation-plan
                                    :rich-content)))
    (when (get-in report-data [:optional-section :enabled?])
      (card
       (some->> report-data
                :optional-section
                :heading-text)
       (text-content/rich-content (some->> report-data
                                           :optional-section
                                           :rich-content)))))))

(defn- valuation
  [valuation]
  (card
   "Valuation"
   {:svg   (chart-view/chart-svg "highcharts" (:figures valuation))
    :width 400}
   (text-content/optional-footer valuation)))

(defn- money-multiple
  [money-mulltiple-distribution]
  (card
   "Money multiple distribution"
   {:svg   (chart-view/chart-svg "highcharts" (:figures money-mulltiple-distribution))
    :width 400}
   (text-content/optional-footer money-mulltiple-distribution)))

(defn- valuation-ownership-pages
  [company-name valuation-data money-multiple-distribution valuation-text ownership-data]
  (concat [(page/page
            (page/page-title {:page-title company-name})
            (columns
             (column
              (card
               "Valuation principles"
               (text-content/rich-content (-> valuation-text
                                              :rich-content))))
             (money-multiple money-multiple-distribution)))]
          (table/dynamic-table-pages {:page-title company-name}
                                     "Ownership"
                                     ownership-data
                                     {:odd-color     (theme/color [:pdf :table :odd-color])
                                      :even-color    (theme/color [:pdf :table :even-color])
                                      :heading-color (theme/color [:pdf :table
                                                                   :heading-color])})))

(defn holding-pages
  "PDFMake page definitions for Private Equity holding Company to be passed to
  `frontend.ui.page.lp-portal.report.pdf.view/report` in production. See `company-pages`."
  [{:keys [holding-name
           valuation
           money-multiple-distribution
           valuation-text
           ownership]
    :as   report-data}]
  (concat
   (overview-pages report-data)
   [(company-3-page report-data)
    (value-creation-plan-page report-data)]
   (valuation-ownership-pages holding-name
                              valuation
                              money-multiple-distribution
                              valuation-text
                              ownership)))
